import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { IPushOrderState, SLICE_NAME, initialState } from './models';
import { pushOrder } from './actionCreators';

export const pushOrderSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(isPending(pushOrder), (state: IPushOrderState) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(isFulfilled(pushOrder), (state: IPushOrderState) => {
        state.isLoading = false;
      })
      .addMatcher(isRejected(pushOrder), (state: IPushOrderState, action) => {
        const { error } = action;
        state.isLoading = false;
        state.error = error;
        showApiErrors(error);
      });
  },
});
